import Vue from 'vue';
import * as AuthService from './auth.service';

console.log("API URL :" + process.env.API_URL);

const BASE_URL = process.env.API_URL;
const API_KEY = process.env.API_KEY;

const pagination = {
  resource: '',
  nextPage: null,
};

export function init(){
  let token = AuthService.getToken();
  Vue.axios.defaults.headers.common['Authorization'] = token;
  Vue.axios.defaults.headers.common['X-API-Key'] = `${API_KEY}`;
}

export function show(url, id, params, cb){
  init();
  let full_url = `${BASE_URL}${url}/${id}`;
  Vue.axios.get(full_url, {params: params}).then((response) => {
    cb(response.data, null);
  }).catch(error => {
    handleError(error, cb);
  });
}

export function index(url, params, cb){
  init();
  let full_url = `${BASE_URL}${url}`;
  Vue.axios.get(full_url, {params: params}).then((response) => {
    cb(response.data, null);
  }).catch(error => {
    handleError(error, cb);
  });
}

export function post(url, params, cb){
  init();
  let full_url = `${BASE_URL}${url}`;
  Vue.axios.post(full_url, params).then((response) => {
    cb(response.data, null);
  }).catch(error => {
    handleError(error, cb);
  });
}

export function update(url, id, params, cb){
  init();
  let full_url = `${BASE_URL}${url}/${id}`;
  Vue.axios.put(full_url, params).then((response) => {
    cb(response.data, null);
  }).catch(error => {
    handleError(error, cb);
  });
}

export function remove(url, id, cb){
  init();
  let full_url = `${BASE_URL}${url}/${id}`;
  Vue.axios.delete(full_url).then((response) => {
    cb(response.data, null);
  }).catch(error => {
    handleError(error, cb);
  });
}

export function handleError(error, cb){
  console.log(error);
  if(error.response.status == 401){
    AuthService.logout();
    window.vm.$children[0].is_logged_in = false;
    window.vm.$router.push({name: 'Signin'}); // window.location = "#/signin"
    // window.history.go('/signin');
  }
  cb(null, error.response.data.error);
}



// WEBPACK FOOTER //
// ./src/services/http.service.js